<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <button
      type="button"
      class="btn btn-primary"
      :class="getDisableClass"
      @click="onClickPreview()"
    >
      {{ $t("Preview") }}
    </button>
  </div>
</template>
<script>
import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(usePackingOptionsStore, [
      "getPackingOptionsData",
      "getPreviewLoading"
    ]),
    getDisableClass: function () {
      return this.getPreviewLoading ? "disable" : "";
    }
  },
  methods: {
    ...mapActions(usePackingOptionsStore, ["packingGetData"]),
    onClickPreview: function () {
      // debounce ???
      this.packingGetData({ wnd: this, callChangeOptions: true });
    }
  }
};
</script>
